let counter = 0;

/** Generate a unique linkId for questionnaire items */
export function generateLinkId(): string {
  counter++;
  const random = Math.random().toString(36).substring(2, 8);
  return `item-${Date.now()}-${counter}-${random}`;
}
